/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Checkbox/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Checkbox({
  children,
  viewPath = "/DesignSystem/Checkbox",
  marginTop = 0,
  onClick,
  isSelected,
  text = "Yes, send me text notifications"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="Checkbox.Checkbox"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-1-1SENI3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-block ${styles.Checkbox1}`}
>
<div
  data-testid="Checkbox.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-2-1SENI3': isSelected ? "rgb(0,147,201)" : "#ffffff",'--bc-3-1SENI3': isSelected ? "rgb(0,147,201)" : isHovered ? "rgba(0,147,201, 0.83)" : "#ebebeb"}}
 className={`views-block ${styles.Horizontal}`}
>
<Check
  viewPath={`${viewPath}/Check`}
 height={14}
 stroke={isSelected ? "#ffffff" : "rgba(0, 0, 0, 0)"}
 width={14}
 opacity={isSelected ? 1 : 0}
/>
</div>
<span
  data-testid="Checkbox.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}